import { AverageAssessmentAnswersByProgramFragment } from "types/graphql-schema";
import { CompetencyCriteriaNode } from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { currentUserVar, isAdminVar } from "@cache/cache";
import TextareaWysiwyg from "@components/wysiwyg/textarea-wysiwyg";

import AverageAssessmentAnswers from "./average-assessment-answers";
import NA from "./na";

const CompetencyCriteria = ({
  criteria,
  averageAssessmentAnswers,
  profile,
}: {
  criteria?: Pick<CompetencyCriteriaNode, "id" | "content">[];
  averageAssessmentAnswers?: AverageAssessmentAnswersByProgramFragment[];
  profile: BasicUser & { isInCurrentUserReportingTree: boolean };
}) => {
  if (!criteria || criteria.length === 0) {
    return <NA />;
  }
  const isAdmin = isAdminVar();
  const currentUser = currentUserVar();
  const canViewAverageAssessmentAnswers =
    profile.id === currentUser.id ||
    profile.isInCurrentUserReportingTree ||
    isAdmin;
  return (
    <div>
      <ul className="">
        {criteria.map((criteriaItem) => (
          <li className="mb-2 flex items-start gap-2.5" key={criteriaItem.id}>
            <div className="bg-gray-300 rounded-full h-[5px] w-[5px] mt-[12px]" />
            <TextareaWysiwyg value={criteriaItem.content} />
          </li>
        ))}
      </ul>
      {canViewAverageAssessmentAnswers && (
        <AverageAssessmentAnswers
          averageAssessmentAnswers={averageAssessmentAnswers}
          profileId={profile.id}
        />
      )}
    </div>
  );
};

export default CompetencyCriteria;
